module.exports = __webpack_public_path__ + "static/media/branding-logo-topbar.499d3d72.png";